import { createFileRoute } from "@tanstack/react-router";
import { WithErrorBoundary } from "../../../hoc/with-error-boundary";
import { withPermissionCheck } from "../../../hoc/with-permission-check";
import { UpdatePasswordView } from "../../../views/profile/update-password/update-password-view";

export const Route = createFileRoute("/_profile/profile/update-password")({
  component: () => WithErrorBoundary({ Component: withPermissionCheck({ Component: UpdatePasswordView }) }),
});
